import http from '@/utils/http.js'
/*
 * @DESC:api接口
 */
const COUPON_LIST = "/api/couponList",//优惠券列表
	COUPON_DETAIL = "/api/couponDetail",//优惠券详情
	COUPON_EDIT = "/api/couponEdit",//编辑优惠券
	COUPON_DEL = "/api/couponDel",//删除优惠券
	COUPON_STATISTICS = "/api/couponStatistics";//数据分析

export default {
	couponList: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(COUPON_LIST, params);
			commit('COUPON_LIST', data);
		} catch(e) {
			throw e
		}
	},
	couponDetail: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(COUPON_DETAIL, params);
			commit('COUPON_DETAIL', data);
			return data
		}catch(e){
			throw e
		}
		
	},
	couponEdit: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		return http.post(COUPON_EDIT, params);
	},
	couponDel: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		return http.post(COUPON_DEL, params);
	},
	couponStatistics: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(COUPON_STATISTICS, params);
			commit('COUPON_STATISTICS', data);
		} catch(e) {
			throw e
		}
	},
}


// WEBPACK FOOTER //
// ./src/store/mp/marketing/coupon/actions.js